import { json } from "@remix-run/node";
import { useLoaderData, useRouteLoaderData } from "@remix-run/react";
import { Text } from "@chakra-ui/react";

import {
  Layout,
  Header,
  Content,
} from "#app/components/layouts/MarketingPage.jsx";
import { TestimonialHighlight } from "#app/components/index.jsx";
import { Review } from "#app/models/index.js";

import { Pricing, TellMeMore } from "#app/components/pricing/index.jsx";
import { getSeoMeta, getBaseUrl, getDefaultOgImage } from "#app/utils/meta.js";

export function meta({ matches }) {
  const baseUrl = getBaseUrl(matches);
  return getSeoMeta({
    title: "Pricing | Schnerp",
    description:
      "Try for free, subscribe for more. After your free trial, sign up to schnerp your favorite sites all season long",
    url: `${baseUrl}/pricing`,
    image: getDefaultOgImage(baseUrl),
  });
}

export async function loader() {
  const reviews = await Review.getVisibleReviews({ limit: 1, tag: "pricing" });
  return json({ reviews });
}

export default function PricingPage() {
  const { reviews } = useLoaderData();
  const { pricingCurrency } = useRouteLoaderData("root");
  const currencyName = new Intl.NumberFormat("en", {
    style: "currency",
    currency: pricingCurrency,
    currencyDisplay: "name",
    maximumFractionDigits: 0,
  })
    .formatToParts(0)
    .find(({ type }) => type === "currency").value;

  return (
    <Layout>
      <Header
        title="Try for free, subscribe for more"
        subtitle="After your free trial, sign up to schnerp your favorite sites all season long"
      />
      <Content pb="12">
        <Pricing />
        <Text mt={4} color="subtle" fontSize="sm" textAlign="center">
          Prices in {currencyName}
        </Text>
        <TestimonialHighlight review={reviews[0]} />
        <TellMeMore mt={10} />
      </Content>
    </Layout>
  );
}
